import {urlModifyQueryParamsInEncodedUrl} from "@wix/devzai-utils-common";

export function browserOpenNewTab (
    url: string,
    options: {
        rel?: 'noopener' | 'noreferrer' | null
    } = {}
) {
    const {
        rel = 'noreferrer'
    } = options;

    window.open(url, '_blank', rel ?? undefined)
}

export function browserDownloadStringAsFile (str: string, filename: string) {
    const blob = new Blob([str], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.download = filename;
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export function browserDownloadObjectUrlAsFile (url: string, filename: string) {
    const link = document.createElement("a");
    link.download = filename;
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export function browserGetWindowBaseUrl (rootWindow?: Window) {

    const location = (rootWindow ?? window).location;

    return location.protocol + "//" + location.host;
}

export function browserIsIframeWindow (rootWindow: Window) {
    return rootWindow !== rootWindow.top;
}

export function browserModifyCurrentLocationQueryParams (queryParamsModifier: Parameters<typeof urlModifyQueryParamsInEncodedUrl>[1]) {
    const currentPathWithSearch = location.pathname + location.search;
    return urlModifyQueryParamsInEncodedUrl(currentPathWithSearch, queryParamsModifier);
}